import axios from 'axios';
import CODES from './StatusCodes';
import store from 'Redux/Store';
import { API_BASE_URL } from './ApiPaths';

import { isIEBrowser } from 'Helpers/Utils';
import { logoutUser } from 'Redux/Auth';

const METHOD = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete',
    PATCH: 'patch'
};

const BASEURL = API_BASE_URL;

// CHECK BELOW FOR SAMPLE DATA TO BE PASSED
class Api {
    isLoggedIn = true;

    constructor() {
        this.baseURL = BASEURL;
        this.getAuthenticationInfo();
    }

    getAuthenticationInfo() {
        if (sessionStorage.getItem('isLoggedIn')) {
            this.isLoggedIn = true;
            this.accessToken = sessionStorage.getItem('accessToken');
        }
    }

    // URL FOR API
    // REFER SAMPLE JSON AT BOTTOM FOR DATA VALUES
    get(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.GET, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    post(url, data, headers) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.POST, url, data, headers)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    put(url, data, headers) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.PUT, url, data, headers)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    delete(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.DELETE, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    patch(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.PATCH, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    api(method, url, data, otherHeaders) {
        return new Promise((resolve, reject) => {
            let axiosConfig = {};
            axiosConfig.method = method;

            axiosConfig.url = this.baseURL + url;
            axiosConfig.headers = this.setHeaders(data, otherHeaders ?? {});
            if (data) {
                if (data.params) axiosConfig.params = data.params;

                if (data.data) axiosConfig.data = data.data;
            }

            if (isIEBrowser()) {
                if (!axiosConfig.params) axiosConfig.params = {};
                axiosConfig.params.time = new Date().getTime();
            }

            axios(axiosConfig)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status === CODES.UNAUTHORIZED) {
                            if (!error.response.data) error.response.data = {};
                            error.response.data.message = 'Session expired';
                            store.dispatch(logoutUser());
                        }
                        // Ensure message exists so UI doesn't always show "Internal Server Error"
                        if (!error.response.data || typeof error.response.data.message === 'undefined') {
                            error.response.data = error.response.data || {};
                            error.response.data.message =
                                error.response.data.message ||
                                (error.response.status >= 500
                                    ? 'Server error. Please try again.'
                                    : `Request failed (${error.response.status}).`);
                        }
                    } else {
                        // No response: CORS, network error, or wrong API URL (e.g. REACT_APP_API_URL missing in build)
                        error.response = {
                            data: {
                                message:
                                    !this.baseURL || this.baseURL === 'undefined'
                                        ? 'API URL not set. Set REACT_APP_API_URL when building for production.'
                                        : 'Request failed. Check API URL and CORS settings.'
                            }
                        };
                    }
                    console.error('TCL: Api -> api -> error', error);
                    reject(error);
                });
        });
    }

    setHeaders(data, otherHeaders) {
        let headers = {};
        // headers['ngrok-skip-browser-warning'] = '6024';
        headers['accept-language'] = 'en';
        headers['device_type'] = 'CMS';
        headers['Content-Type'] = 'application/json';
        headers['country'] = 'India';
        headers['latitude'] = '20.5937';
        headers['longitude'] = '78.9629';

        headers['X-API-KEY'] = process.env.REACT_APP_X_API_KEY || '';
        Object.entries(otherHeaders).map((lists) => (headers[lists[0]] = lists[1]));
        if (data) {
            if (data.isMultipart) {
                headers['Content-Type'] = 'multipart/form-data';
            }

            if (data.headers) {
                for (var key in data.headers) {
                    if (Object.prototype.hasOwnProperty.call(data.headers, key)) {
                        headers[key] = data.headers[key];
                    }
                }
            }
        }

        if (this.isLoggedIn !== false && !(data && data.skipAuth)) {
            headers['accessToken'] = sessionStorage.getItem('accessToken');
        }
        return headers;
    }
}

// SAMPLE DATA JSON
/* let sample_data = {

    // ADDITIONAL HEADERS IF REQUIRED
    headers :{
        'Content-type'  : 'xx-urlencode',
    },

    // IF USER ID AND TOKEN SHOULDN'T BE PASSED IN HEADERS (USER FOR AFTER LOGIN API)
    // DEFAULT : FALSE;
    skipAuth    : false,

    // IF Default error handling needs to be overridden
    // DEFAULT : FALSE;
    skipErrorHandling    : false,

    // FOR SENDING FILES OR FORM DATA REQUEST
    isMultipart : true,

    // `PARAMS` ARE THE URL PARAMETERS TO BE SENT WITH THE REQUEST
    params : {
        user_id     : 10,
        name        : "lorem",
        page        : 3,
        sort_by     : 'name'
    },

    // POST DATA
    data : {
        firstName   : 'Lorem',
        lastName    : 'Ipsum'
    },
} */

export default Api;
